import TEConfirm from './TEConfirm';

export default TEConfirm;
